'use client';

import { ChannelHeroCard } from "@/components/molecules/ChannelHeroCard";
import { useLiveChannel } from "@/hooks";
import { getXMChannelSchedules } from '@/packages/sxm/epg/epgClient';
import { useState } from "react";

export interface ClientChannelCardProps {
    channel: SiteChannel;
};

export default function ClientChannelCard({ channel } : ClientChannelCardProps) {
    const [album, setAlbum] = useState({
        title: '',
        artist: '',
        art: '',
    });

    const getChannelEpg = async (channelId: string) => {
        const channelEpg = await getXMChannelSchedules(channelId, '/');
        setAlbum({
            title: channelEpg?.nowplaying?.[0]?.name || '',
            artist: '',
            art: channelEpg?.nowplaying?.[0]?.logo,
        });
    };

    useLiveChannel([channel.fields.id], (response: MountainResponse) => {
        const nowPlayingChannel = response.channels;
        const firstKey = response?.channels ? Object.keys(response.channels)[0] : undefined;
        const category = (firstKey && response.channels?.[firstKey].category) || channel.fields.genre?.fields.category?.fields.key;

        if (response?.channels && firstKey && category !== 'music') {
            getChannelEpg(response.channels[firstKey].channel_id);
        } else if (nowPlayingChannel) {
            setAlbum({
                title: nowPlayingChannel[channel.fields.id].content.title || '',
                artist:
                    (nowPlayingChannel[channel.fields.id].content.artists &&
                        nowPlayingChannel[channel.fields.id].content.artists[0]?.name) ||
                    '',
                art: nowPlayingChannel[channel.fields.id].content.album?.art || '',
            });
        }
    });

    return (<>
        <ChannelHeroCard
            color={channel.fields.primary_color || 'var(--black)'}
            channelCardProps={{
                listenLink: channel.fields.deep_link_to_player ?? '',
                listenLinkAriaLabel: `listen live to ${channel.fields.display_name}`,
                title: album.title,
                subTitle: album.artist,
                borderColor: channel.fields.primary_color || 'var(--black)',
                radioImageUrl: channel.fields.color_logo?.url || '',
                radioImageAlt: '',
                albumImageSrc: album.art,
                albumImageAlt: '',
                disableShadow: true,
            }}
        />
    </>)
}